import { prepareRequest } from './request'

export const getAvailableDates = ({ signal = null }) => {
  const request = prepareRequest({
    // url: 'racing/dates',
    url: 'racing/init',
    method: 'GET',
    signal
  })
  return request()
}

export const getMeetsByDate = ({ isoDate, signal = null }) => {
  const request = prepareRequest({
    method: 'GET',
    url: '/racing/meetings',
    query: {
      date: isoDate
    },
    signal
  })
  return request()
}

export const getFutureMeetings = ({ fromIsoDate, toIsoDate, signal = null }) => {
  const request = prepareRequest({
    method: 'GET',
    url: '/racing/futures',
    query: {
      fromDate: fromIsoDate,
      toDate: toIsoDate,
    },
    signal
  })
  return request()
}

export const getRaceById = ({ raceId, signal = null }) => {
  const request = prepareRequest({
    method: 'GET',
    url: '/racing/race',
    query: {
      raceId: raceId
    },
    signal
  })
  return request()
}

export const getLegRaceById = ({ raceId, signal = null }) => {
  const request = prepareRequest({
    method: 'GET',
    url: '/racing/legRace',
    query: {
      raceId: raceId
    },
    signal
  })
  return request()
}

export const getOutcomeById = ({ outcomeId, signal = null }) => {
  const request = prepareRequest({
    method: 'GET',
    url: '/racing/outcome',
    query: {
      id: outcomeId
    },
    signal
  })
  return request()
}

export const getSameRaceMultiRunners = ({ raceId, signal = null }) => {
  const request = prepareRequest({
    method: 'GET',
    url: '/racing/srmOdds',
    query: {
      raceId: raceId
    },
    signal
  })
  return request()
}

export const getSameRaceMultiOutcome = ({ data, signal = null }) => {
  const request = prepareRequest({
    method: 'POST',
    url: '/racing/srmOutcome',
    signal
  })
  return request(data)
}

export const getCombinedOutcome = ({ data, signal = null }) => {
  const request = prepareRequest({
    method: 'POST',
    url: '/racing/combinedOutcome',
    signal
  })
  return request(data)
}

export const getExoticMarketOutcome = ({ data, signal = null }) => {
  const request = prepareRequest({
    method: 'POST',
    url: '/racing/exoticsOutcome',
    signal
  })
  return request(data)
}

export const getMultilegsOutcome = ({ data, signal = null }) => {
  const request = prepareRequest({
    method: 'POST',
    url: '/racing/multilegsOutcome',
    signal
  })
  return request(data)
}

export const getBasicRunnersInfo = ({ data, signal = null }) => {
  const request = prepareRequest({
    method: 'POST',
    url: '/racing/basicRunnersInfo',
    signal
  })
  return request(data)
}

export const getRaceOddsHistories = ({ raceId, signal = null }) => {
  const request = prepareRequest({
    method: 'GET',
    url: '/racing/raceOddsHistories',
    query: {
      raceId: raceId
    },
    signal
  })
  return request()
}

export const getRaceStatic = ({ raceId, signal = null }) => {
  const request = prepareRequest({
    method: 'GET',
    url: '/racing/raceStatic',
    query: {
      raceId: raceId
    },
    signal
  })
  return request()
}

export const getNextRaces = ({ signal = null }) => {
  const request = prepareRequest({
    method: 'GET',
    url: '/racing/nextRaces',
    signal
  })
  return request()
}
